import React from 'react';
import update from 'immutability-helper';
import BtButton from '../bt-button/bt-button';
import 'react-datepicker/dist/react-datepicker.css';
import './app-project-single-purchase.css';
import styles from './app-project-single-purchase.module.scss';
import _ from 'lodash';
import $ from 'jquery';
import { ServiceProjects } from '../../services/service-projects';
import moment from 'moment';
import 'moment/locale/sv.js';
import 'moment/locale/nb.js';
import 'moment/locale/da.js';
import { ServiceExcel } from '../../services/service-excelController';
import { NotificationManager } from 'react-notifications';
import { ServiceDownload } from '../../services/service-download';
import { formatAmount } from '../../util';
import BlockIcon from '@material-ui/icons/Block';
import OptionsMenu from '../../components/shared/OptionsMenu/OptionsMenu';
import TooltipContainer from '../../components/shared/TooltipContainer/TooltipContainer';
import { withRouter } from 'react-router-dom';
import appState from '../../state/AppStateContainer';
import Toolbar from '../../components/shared/Toolbar/Toolbar';
import { TrashIcon } from '../../components/svgs';
import GroupIcon from '../../components/svgs/groupIcon';
import PhoneIcon from '../../components/svgs/phoneIcon';
import MailIcon from '../../components/svgs/emailIcon';
import ArrowIcon from '../../components/svgs/arrowIcon';
import AddIcon from '../../components/svgs/addIcon';
import UploadIcon from '../../components/svgs/uploadIcon';
import WinnerIcon from '../../components/svgs/winnerIcon';
import { SearchIcon2 } from '../../components/svgs/searchIcon2';
import ContractIcon from '../../components/svgs/contractIcon';
import MessageLog from '../../components/shared/MessageLog/MessageLog';
import Selector from '../../components/shared/Selector/Selector';
import Modal from '../../components/shared/Modal/Modal';
import TitleWrapper from '../../components/shared/TitleWrapper/TitleWrapper';
import { ServiceUser } from '../../services/service-user';
import ExcelIcon from '../../assets/images/excel.png'
import { BidIntentStatus } from '../page-quotation/BidIntentControls/BidIntentControls';
import { ReactComponent as PlusIcon } from '../../assets/svg/circlePlusIcon.svg';
import SupplierBlockedReasons from '../app-supplier-database/supplier-blocked-reasons';
import DateExtensionModal from '../app-project-overview-item/DateExtensionModal';
import { FileScope, PrequalificationDecision } from '../../util/appEnum';
import { getImageUrl } from '../../components/shared/ImagePreview/ImagePreview';
import Field from '../../components/shared/Field/Field';
import ContractModal from '../app-project-overview-item/ContractModal';
import Card from '../../components/shared/Card/card';
import BidOverview from './bid-overview';
import NotificationCounter from '../../components/shared/NotificationCounter/NotificationCounter';
import TeamBuilder from '../../components/shared/TeamBuilder/TeamBuilder';
import TableField from '../app-project-purchase-list/TableField/TableField';
import TableDatePicker from '../app-project-purchase-list/TableDatePicker/TableDatePicker';
import { getDaysLeft } from '../../util';
import { withTranslation } from 'react-i18next';
import FileArea from '../page-files/FileArea';
import Editor from '../../components/shared/Editor/Editor';
import { htmlToPlainTest } from '../../util';
import NotesPencilIcon from '../../components/svgs/notesPencilIcon';

const MAX_TEAM_SIZE = 5;

function shortFilename(file, strLen = 20, separator = "...") {
  if (file.length < strLen) return file;

  var ext = file.slice(((file.lastIndexOf(".") - 1) >>> 0) + 2);
  var fileName = file
    .split(".")
    .slice(0, -1)
    .join(".");
  file = fileName;
  strLen -= ext.length + 1;

  const sepLen = separator.length,
    charsToShow = strLen - sepLen,
    frontChars = Math.ceil(charsToShow / 2),
    backChars = Math.floor(charsToShow / 2);

  return (
    file.substr(0, frontChars) +
    separator +
    file.substr(file.length - backChars) +
    "." +
    ext
  );
}

const formatDate = (date) => date ? moment(date).locale('sv').format('D MMMM YYYY HH:mm') : '';

class AppProjectSinglePurchase extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      progress: props.progress || 100,
      label: props.label || null,
      priceTypes: this.getPriceTypes(props.suppliers),
      budgetVal: props.budget || '',
      selectedItem: null,
      versionData: [],
      suppliers: this.sortSuppliers(props.suppliers),
      selectedFile: 1,
      attachments: this.props.attachments,
      showRiskIndicator: false,
      showRiskLoader: false,
      fetchedAnalysis: false,
      lockedButtonDisable: false,
      showPhoneLogModal: false,
      phoneLogValue: '',
      phoneLogLoading: false,
      phoneLogRefreshKey: 0,
      localPhoneLogDetails: [],

      areaUsers: [],
      showWinnerModal: false,
      winnerValue: null,
      showOnlyWinningSupplier: true,
      showSupplierThatDeclined: false,
      showDateExtensionModal: false,
      sendAgain: {},
      agreementModalKey: 0,
      showAllVersions: false,
      temporaryAreaLeadTime: {},
      showMassMessagingModal: false,
      massMessagingEditorValue: '',
      purchases: [],
      massMessagingFilters: [],
      massMessagingRecipientSelection: {},
      shownRecipients: [],
      searchString: '',
      fileAreaPath: '/',
    };
  }

  // We use it to scroll at the bottom of the phone log div
  phoneLogDiv = null;

  getTheLatestVersionForSuppliers = ({ versionData, suppliers }) => {
    const getVersion = versionData && !_.isEmpty(versionData) ? versionData[0].versions : undefined;

    if (suppliers?.length && getVersion) {
      const latestVersions = {};
      suppliers.forEach(supplier => {
        const { supplierId } = supplier;
        const version = `version${supplierId._id}`;
        const quotationVersions = [];

        for (const qv of getVersion) {
          for (const s of qv.suppliers) {
            if (s.supplierId === supplierId._id) quotationVersions.push(qv);
          }
        }

        if (!_.isEmpty(quotationVersions)) {
          const latestVersion = quotationVersions[quotationVersions.length - 1].refVersion;
          latestVersions[version] = latestVersion;
        }
      });
      return latestVersions;
    }
  }

  checkContractSigning = () => {
    const { step } = this.props;

    if(step == 3 || step == 4){
      const area = this.props.currentProject.area.find(a => a.areaId._id == this.props.areaId);
      const signedContractExists = area?.contracts?.find(contract => contract?.lastStatus === "closed");
      if(step == 3 && (signedContractExists || area?.manualContract?.length)) this.changeStep(4);
      else if(step == 4 && !signedContractExists && !area?.manualContract?.length) this.changeStep(3);
    }
  }

  async componentDidMount() {
    const { areaId } = this.props;
    if (areaId) {
      this.checkContractSigning();

      let currentProject = this.props.currentProject;
      let projectSlug = currentProject.slug;
      let areaId = this.props.areaId;
      const versionData = await ServiceProjects.getVersionData(projectSlug, areaId);

      ServiceUser.getProjectUsersAreas(currentProject._id).then(res => {
        const areaU = res
          .filter(user => user.areaIds.indexOf(areaId) != -1)
          .map(user => {
            const userDetails = this.props.users.find(e => e.value == user.userId);
            return userDetails ? { name: userDetails.label, _id: userDetails.value, avatarUrl: user.avatarUrl } : null;
          }).filter(user => user);
        this.setState({ areaUsers: areaU });
      });

      this.setState(
        {
          versionData: versionData,
          attachments: this.props.attachments,
        },
        () => {
          this.setState(
            {
              suppliers: this.sortSuppliers(this.props.suppliers),
              priceTypes: this.getPriceTypes(this.props.suppliers, {
                versionPrice: true,
              }),
            },
            () => this.setState(this.getTheLatestVersionForSuppliers({ versionData, suppliers: this.state.suppliers }))
          );
        },
      );
    }
  }

  getNewlyUpdatedLatestVersionsPerSupplier = (oldState, newState) => {
    const toChange = {};
    if (!oldState) {
      return { ...newState };
    }
    if (newState) {
      for (const [key, value] of Object.entries(newState)) {
        if (value != oldState[key]) {
          toChange[key] = value;
        }
      }
    }
    return toChange;
  }

  async UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      !_.isEqual(this.props.currentProject, nextProps.currentProject) && (
        this.props.dateEnd != nextProps.dateEnd ||
        _.isEqual(this.props.suppliers, nextProps.suppliers) ||
        nextProps.suppliers.length
      )
    ) {
      let currentProject = this.props.currentProject;
      let projectSlug = currentProject.slug;
      let areaId = this.props.areaId;
      let versionData = this.state.versionData;
      const oldLatestVersionPerSupplier = this.getTheLatestVersionForSuppliers({ versionData, suppliers: this.state.suppliers });
      versionData = await ServiceProjects.getVersionData(projectSlug, areaId);
      const nextSuppliers = this.sortSuppliers(nextProps.suppliers);
      const newLatestVersionPerSupplier = this.getTheLatestVersionForSuppliers({ versionData, suppliers: nextSuppliers });
      const updatedLatestVersionsPerSupplier = this.getNewlyUpdatedLatestVersionsPerSupplier(
        oldLatestVersionPerSupplier,
        newLatestVersionPerSupplier
      );

      const shouldUpdateAttachments = !_.isEqual(this.state.attachments, nextProps.attachments);

      this.setState({
        versionData: versionData,
        attachments: shouldUpdateAttachments ? nextProps.attachments : this.state.attachments,
        suppliers: nextSuppliers,
        progress: nextProps.progress,
        label: nextProps.label,
        priceTypes: this.getPriceTypes(nextProps.suppliers, {
          versionPrice: true,
        }),
        ...updatedLatestVersionsPerSupplier
      });
    }
  }

  dispatchWinnerChange(supplier, isRemoved) {
    if (this.props.winnerChangeEvent) {
      this.props.winnerChangeEvent(supplier, isRemoved);
    }
  }

  addWinnerClickCallback(extraData) {
    this.updateWinnerState(extraData._id, true);
    this.dispatchWinnerChange(extraData, false);
  }

  removeWinnerClickCallback() {
    const suppliers = this.state.suppliers;
    const suppliersToBeRemoved = suppliers.filter(s => s.reward);

    suppliersToBeRemoved.forEach(supplierToBeRemoved => {
      if (supplierToBeRemoved) {
        this.updateWinnerState(supplierToBeRemoved.supplierId._id, false);
        this.dispatchWinnerChange(supplierToBeRemoved.supplierId, true);
      }
    })
  }

  updateWinnerState(supplierId, isRewarded) {
    let suppliers = this.state.suppliers;
    let newSupplierIndex = suppliers.findIndex(s => s.supplierId._id == supplierId);
    let newSuppliers = update(suppliers, {
      [newSupplierIndex]: { reward: { $set: isRewarded } },
    });
    this.setState({ suppliers: newSuppliers });
  }

  getQuoteValidity(validity) {
    return validity ? moment(validity).format('YYYY-MM-DD') : ""
  }

  parseDateEnd(dateEnd) {
    if (dateEnd == '' || dateEnd == '-' || dateEnd == undefined) {
      return '-';
    }
    return Date.parse(dateEnd);
  }

  getDaysLeft(dateEnd) {
    var endDate = this.parseDateEnd(dateEnd);
    if (!endDate || endDate == '-') {
      return '-';
    }

    var today = new Date();
    var month = today.getMonth() + 1;
    month = month < 10 ? '0' + month : month;

    var day = today.getDate();
    day = day < 10 ? '0' + day : day;

    var date = today.getFullYear() + '-' + month + '-' + day;
    var startDate = Date.parse(date);
    var timeDiff = endDate - startDate;
    var daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

    return daysDiff;
  }

  getPriceTypes(suppliers, options = {}) {
    if (options.versionPrice && this.state.versionData[0] && this.state.versionData[0].versions) {
      const priceTypesclone = _(
        this.state.versionData[0].versions.map(p => p.priceDetails.map(pd => pd.priceType)),
      )
        .flatMap()
        .value();

      return _.uniqBy(priceTypesclone, '_id');
    } else {
      let priceTypes = [];
      if (suppliers && suppliers.length > 0) {
        let index = suppliers.findIndex(supplier => {
          return supplier.priceDetails && supplier.priceDetails.length > 0;
        });

        if (index != -1) {
          suppliers[index].priceDetails.forEach(priceDetail => {
            priceTypes.push(priceDetail.priceType);
          });
        }
      }
      return priceTypes;
    }
  }

  sortSuppliers(suppliers) {
    if (!(suppliers instanceof Array)) return null;
    return suppliers;
  }

  btnAddTextBoxClick(item) {
    const phoneLogDetails = this.getCallDetails(item);
    this.setState({ 
      selectedItem: item, 
      showPhoneLogModal: true, 
      localPhoneLogDetails: phoneLogDetails 
    }, () => {
      if (this.phoneLogDiv) {
        // Added a small delay before we scroll in the div because it kept resetting once the div was rendered
        setTimeout(() => {
          const scrollHeight = this.phoneLogDiv.scrollHeight;
          const height = this.phoneLogDiv.clientHeight;
          const maxScrollTop = scrollHeight - height;
          this.phoneLogDiv.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
        }, 50);
      }
    });
  }

  getMeeting = (val, item) => {
    this.setState({ [`meeting${item.supplierId._id}`]: val });
    if (this.props.onChangeMeeting) {
      this.props.onChangeMeeting(val, item);
    }
  };

  getLocalDateTime(givenDate) {
    const utcDate = givenDate.toString();
    const gmtDateTime = moment.utc(utcDate);
    const local = gmtDateTime.local().format('YYYY-MMM-DD h:mm A');
    return moment(local, 'YYYY-MMM-DD h:mm A').format('llll');
  }

  removeDuplicates(originalArray, prop) {
    var newArray = [];
    var lookupObject = {};

    for (var i in originalArray) {
      lookupObject[originalArray[i][prop]] = originalArray[i];
    }
    for (i in lookupObject) {
      newArray.push(lookupObject[i]);
    }
    return newArray;
  }

  onCalendar = (item, v, version) => {
    const length = v.length ? v.length : 0;
    this.setState({
      currentSelectedVersion: version && version.refVersion ? version.refVersion : null,
      selectedVersionLength: length,
      selectedItem: item,
      showDateExtensionModal: true,
    });
  };

  onSave = async data => {
    const { selectedItem, selectedVersionLength = [], currentSelectedVersion } = this.state;
    data.version = selectedVersionLength;
    data.currentVersion = currentSelectedVersion;
    await this.props.onSupplierDate(data, selectedItem);
    this.setState({
      showDateExtensionModal: false,
    });
  };

  calcDaysLeft = date => {
    const dateEnd = this.getLocalDateTime(moment(date).startOf('day').toDate());
    return this.getDaysLeft(dateEnd);
  };

  isEmpty = str => {
    return $.trim($('<div>' + str + '</div>').text()) === '';
  };

  exportBidCardInfoOnExcel = async () => {
    const { label, suppliers, budgetVal, versionData } = this.state;
    suppliers.map(item => {
      let sup = item.supplierId;
      const version = `version${sup._id}`;
      item.selectedVersion = this.state[version];
    });
    let data = {
      versionData,
      label: label,
      slug: this.props.currentProject.slug,
      suppliers: suppliers,
      areaId: this.props.areaId,
      priceTypes: this.state.priceTypes,
      budgetVal: budgetVal,
    };
    ServiceExcel.exportExcel(data);
  }

  elBtnAttachClickCallback = () => {
    this.elInputFile.click();
  };

  async elInputFileChangeCallback(e) {
    const {t} = this.props;
    var files = e.target.files;
    var re = /(\.xls|\.xlsx|\.xlt|\.xla|\.xltx)$/i;
    if (re.exec(files[0].name)) {
      let slug = this.props.currentProject.slug;
      let file = files[0];
      this.setState({
        excelFiles: files[0],
      });
      const response = await ServiceExcel.uploadExcel(file, slug, this.props.areaId);

      const project = {...this.props.currentProject};
      const projectArea = project.area.find(area => area.areaId._id == this.props.areaId);
      if (projectArea?.attachment) {
        projectArea.attachment.push(response.data);
      } else {
        projectArea.attachment = [response.data];
      }
      this.props.setCurrentProject(project);

      const updatedAttachments = projectArea?.attachment || [];
      this.setState({ attachments: updatedAttachments });

      NotificationManager.success(
        t('notification.success.fileUpload.description', 'Uppladdning klar'),
        t('notification.success.fileUpload.title', 'Sparat')
      );
    } else {
      NotificationManager.error(
        this.props.t('notification.error.fileUpload.description', 'Det går inte att ladda upp detta {{fileName}}', { fileName: files[0].name }),
        this.props.t('notification.error.fileUpload.title', 'Fel')
      );
    }
  }

  getFileExtension(file) {
    return file.slice(((file.lastIndexOf('.') - 1) >>> 0) + 2);
  }

  isWinnerAvailable() {
    return this.state.suppliers.some(s => s.reward == true);
  }

  changeStep = (nextStep, skipStepChange) => {
    this.props.changeStepEvent(nextStep, skipStepChange);
  };

  changeSupplierVersion = (selectedVersion, supplierId) => {
    /*
      check if current selected version is same as the version user selected,
      if same, just close the dropdown and return
    */
    const version = `version${supplierId._id}`
    if (selectedVersion == this.state[version]) {
      return;
    }
    // else, set new version as selected and close the dropdown
    this.setState({ [version]: selectedVersion });
  };

  shouldStyleSupplierAsNotSelected = (supplier) => {
    return !supplier.reward &&
      this.props.allowEditing &&
      this.isWinnerAvailable();
  }

  getCallDetails = (supplier) => {
    if (supplier && supplier.callDetails && supplier.callDetails.length) {
      const sorted = [...supplier.callDetails]
        .sort((a, b) => new Date(a.date) - new Date(b.date))
        .map(element => {
          const user = this.props.currentProject.usersFromCallDetails.find(user => user._id == element.userId);
          if (user) {
            return {
              ...element,
              name: user.name,
              avatarUrl: getImageUrl(user.imgId, appState.getCurrentOrgSlug(), FileScope.UserAvatar, { userId: user._id })
            }
          }
          return element;
        });
      return sorted;
    }
    return [];
  }

  refreshPhoneLogDetails = () => {
    this.setState({ phoneLogRefreshKey: Date.now() });
    
    setTimeout(() => {
      if (this.phoneLogDiv) {
        const scrollHeight = this.phoneLogDiv.scrollHeight;
        const height = this.phoneLogDiv.clientHeight;
        const maxScrollTop = scrollHeight - height;
        this.phoneLogDiv.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
      }
    }, 100);
  }

  renderPhoneLogs = (phoneLogDetails) => {
    return phoneLogDetails?.map(
      (element, index) => <MessageLog key={`${element.date}-${index}`} name={element.name} avatarUrl={element.avatarUrl} log={element.detail} timestamp={element.date} />
    );
  }

  getMissingDemands = (supplierBid, version) => {
    const missingDemands = [];
    if (supplierBid) {
      const supplierBidDemands = supplierBid?.demands;
      const demands = version?.demands;
      demands?.forEach(demand => {
        if (!supplierBidDemands?.find(bidDemand => bidDemand?.demandId === demand?.demandId?._id)) {
          missingDemands.push(demand?.demandId);
        }
      })
    }
    return missingDemands;
  }

  getMessage = (supplierBid) => {
    return supplierBid?.message &&
    !(this.isEmpty(supplierBid.message) || supplierBid.message === 'null' || supplierBid.message === null) ? supplierBid.message : '';
  }

  getReservations = (supplierBid) => {
    return supplierBid?.content &&
    !(this.isEmpty(supplierBid.content) || supplierBid.content === 'null' || supplierBid.content === null) ? supplierBid.content : '';
  }

  getSupplierDetails = (supplierId) => {
    if (!supplierId) return null;
    const { versionData } = this.state;
    const version = `version${supplierId}`;
    const versionInState = this.state[version];
    const getVersion = !_.isEmpty(versionData) ? versionData[0].versions : undefined;
    if (versionInState || versionInState == 0) {
      const supplierData = getVersion[versionInState].suppliers.find(
        x => x.supplierId === supplierId,
      );
      const supplierBid = getVersion[versionInState].supplierBids.find(x =>
        x.supplierId === supplierId ? x : null,
      );

      const supplierSlug = this.state.suppliers.find(supplier => supplier.supplierId._id == supplierId).supplierId.slug;
      return {
        intentStatus: supplierData?.intentStatus,
        bidLink: `/${appState._getCurrentOrgSlug()}/projects/${this.props.currentProject.slug}/${this.props.areaSlug}/bid-forms/${supplierSlug}`,
        isSeen: supplierData?.isSeen,
        missingDemands : this.getMissingDemands(supplierBid, getVersion[versionInState]) || [],
        reservations: this.getReservations(supplierBid),
        attachments: supplierBid?.attachments ?? [],
        message: this.getMessage(supplierBid),
        quotationValidity: supplierBid?.quotationValidity,
        isSubmitted: supplierBid?.priceDetails,
        date: getVersion[versionInState].quotationExpiryDate,
        seenAt: supplierData?.seenAt,
      };
    }
  }

  renderSuppliers = () => {
    const {t} = this.props;
    const { suppliers, versionData, showOnlyWinningSupplier, showSupplierThatDeclined } = this.state;
    const isReadOnlyUser = appState.isReadOnlyAccessRole();
    const modifiedSuppliers = suppliers.map(supplier => {
      const supplierDetails = this.getSupplierDetails(supplier?.supplierId?._id);
      return {
        ...supplier,
        bidIntentStatus: supplierDetails?.intentStatus,
        bidLink: supplierDetails?.bidLink,
        missingDemands: supplierDetails?.missingDemands,
        reservations: supplierDetails?.reservations,
        message: supplierDetails?.message,
        attachments: supplierDetails?.attachments ?? [],
        quotationValidity: supplierDetails?.quotationValidity,
        isSubmitted: supplierDetails?.isSubmitted,
        date: supplier.date ?? supplierDetails?.date,
      }
    }).filter(supplier => {
      const stepHasWinningSupplier = this.props.step == 3 || this.props.step == 4;
      if (stepHasWinningSupplier) {
        if (showOnlyWinningSupplier && !supplier.reward) {
          return null;
        }
      } else if (!showSupplierThatDeclined && supplier?.bidIntentStatus?.intent === BidIntentStatus.DECLINED) {
        return null;
      }
      return supplier;
    });

    const getHiddenWinningSuppliersNotifications = () => {
      let notificationCount = 0;
      suppliers?.forEach(s => {
        if (!s.reward && s?.supplierId?.notification) {
          notificationCount += s?.supplierId?.notification?.reduce((count, curr) => (count + curr.count), 0);
        }
      });
      return notificationCount;
    }

    const getHiddenDeclinedSupplierNotification = () => {
      let notificationCount = 0;
      suppliers?.forEach(s => {
        const supplierDetails = this.getSupplierDetails(s?.supplierId?._id);
        if (supplierDetails?.intentStatus?.intent == "DECLINED" && s?.supplierId?.notification){
          notificationCount += s?.supplierId?.notification?.reduce((count, curr) => (count + curr.count), 0);
        }
      })
      return notificationCount;
    }

    const hideShowNotSelectedSuppliersControl = () => {
      const { step } = this.props;
      const { showOnlyWinningSupplier, showSupplierThatDeclined, suppliers } = this.state;
      const numOfHiddenSuppliers = suppliers.length - modifiedSuppliers?.length;
      const hiddenWinningSupplierNotification = getHiddenWinningSuppliersNotifications();
      const hiddenDeclinedSupplierNotification = getHiddenDeclinedSupplierNotification();

      if (suppliers.length) {
        if (step == 3 || step == 4) {
          return (numOfHiddenSuppliers > 0 || !showOnlyWinningSupplier) && (
            <p className='supplierViewControls'>
              {showOnlyWinningSupplier && t('suppliers.viewControls.otherSuppliers', '{{count}} andra leverantörer', { count: suppliers.length - 1 })}{' '}
              <span onClick={() => this.setState({ showOnlyWinningSupplier: !showOnlyWinningSupplier })} className="hiddenSupplierLink">
                {t('suppliers.viewControls.show', 'Visa', { context: showOnlyWinningSupplier ? null : 'onlyWinning' })}
                {showOnlyWinningSupplier && <NotificationCounter className="notificationBadge" counter={hiddenWinningSupplierNotification} />}
              </span>
            </p>
          )
        }
        return (numOfHiddenSuppliers > 0 || showSupplierThatDeclined) && (
          <p className='supplierViewControls'>
            {!showSupplierThatDeclined && t('suppliers.viewControls.declinedSuppliers', '{{count}} leverantörer har tackat nej', { count: numOfHiddenSuppliers })}{' '}
            <span onClick={() => this.setState({ showSupplierThatDeclined: !showSupplierThatDeclined })} className='hiddenSupplierLink'>
              {!showSupplierThatDeclined ? t('suppliers.viewControls.show', 'Visa') : t('suppliers.viewControls.hideDeclined', 'Dölj leverantörer som tackat nej')}
              {!showSupplierThatDeclined && <NotificationCounter className="notificationBadge" counter={hiddenDeclinedSupplierNotification} />}
            </span>
          </p>
        )
      }
    }

    const meetingOptions = [
      {
        value: 'Bokat möte',
        label: t('suppliers.meetingOptions.booked', 'Bokat möte'),
        iconColor: 'var(--yellow-500)'
      },
      {
        value: 'Möte avklarat',
        label: t('suppliers.meetingOptions.done', 'Möte avklarat'),
        iconColor: 'var(--green-500)'
      },
      {
        value: 'Ej möte',
        label: t('suppliers.meetingOptions.none', 'Ej möte'),
        iconColor: 'var(--green-500)'
      }
    ];


    return (
      <>
        <div>
          <div className='suppliersLeftPart'>
            {modifiedSuppliers.map((supplier) => {
              const { supplierId } = supplier;

              if (!supplierId) return null;
              const isBlacklist = supplierId.isBlacklist ? supplierId.isBlacklist : false;
              const blacklistReason = supplierId.blacklistReason ? supplierId.blacklistReason : [];

              let quotationVersions = [];
              let eyeIcon = supplier?.isSeen;

              const getVersion = !_.isEmpty(versionData) ? versionData[0].versions : undefined;

              // push all relative versions of the supplier
              if (!_.isEmpty(getVersion)) {
                for (const qv of getVersion) {
                  for (const s of qv.suppliers) {
                    if (s.supplierId === supplierId._id) quotationVersions.push(qv);
                  }
                }
              }

              quotationVersions = this.removeDuplicates(quotationVersions, '_id');

              const hasCallDetails = supplier.callDetails?.length > 0;

              const removeSupplier = async () => {
                const { _id, name, notification } = supplier.supplierId;
                if (window.confirm(t('suppliers.confirm.remove', 'Är du säker på att du vill radera denna leverantör {{name}}?', { name }))) {
                  const { currentProject } = this.props;
                  try {
                    const projectSlug = currentProject.slug;

                    await ServiceProjects.dbRemoveSupplier(projectSlug, this.props.areaId, _id);
                    if (notification && notification.length) notification.map(supMember => clearNotification(supMember));
                    const areaSuppliers = this.state.suppliers.filter(supplier => supplier.supplierId._id != _id).map(supplier => ({ supplierId: supplier.supplierId }));
                    ServiceProjects.replaceAreaSuppliersBySlug(projectSlug, this.props.areaId, areaSuppliers);
                    if (areaSuppliers?.length === 0) {
                      this.setState({ suppliers: [] });
                    }
                  } catch (error) {
                    console.log("Error on removing supplier==>", error)
                  }
                }
              };

              const clearNotification = notObj => {
                if (!notObj || !Object.keys(notObj).length) return;

                const { currentProject } = this.props;
                const currentProjectAreas = currentProject?.area;

                if (!currentProjectAreas?.length) return;

                currentProjectAreas.map(area => {
                  const { areaId, suppliers } = area;

                  if (areaId?.notification?.length) {
                    const areaIndex = areaId.notification.findIndex(
                      el => el.supplierMemberId === notObj.supplierMemberId && el.areaId === notObj.areaId,
                    );
                    if (areaIndex >= 0) areaId.notification.splice(areaIndex, 1);
                  }

                  if (suppliers?.length) {
                    for (let i = 0; i < suppliers.length; i++) {
                      const sup = suppliers[i];
                      const { supplierId } = sup;

                      if (supplierId?.notification?.length) {
                        const supIndex = supplierId.notification.findIndex(
                          el => el.supplierMemberId === notObj.supplierMemberId && el.areaId === notObj.areaId,
                        );

                        if (supIndex >= 0) supplierId.notification.splice(supIndex, 1);
                      }
                    }
                  }

                  return area;
                });
              };
              const getToolbarActions = () => {
                const renderMailIcon = () => {
                  const notificationCount = supplierId.notification && supplierId.notification.reduce((prev, curr) => (
                    { count: prev.count + curr.count }
                  ), { count: 0 }).count;

                  const hasMessages = supplierId.totalMessagesFromSuppliers > 0;
                                    
                  return (
                    <div className='mailIconContainer'>
                      {notificationCount > 0 && <div>{notificationCount}</div>}
                      <MailIcon color={hasMessages ? 'var(--yellow-500)' : undefined} />
                    </div>
                  )
                };

                const phoneIcon = (
                  <NotesPencilIcon color={hasCallDetails ? 'var(--yellow-500)' : undefined} />
                );

                const url = appState._getCurrentOrgUrl();

                const linkToSupplierChat = `${url}/projects/${this.props.currentProject.slug}/${this.props.areaSlug}/${supplierId.slug}`;
                const actions = [
                  { title: t('suppliers.toolbar.tooltip.messages', 'Meddelanden – Skicka mail till leverantören, läs inkommande meddelanden och anbud.'), component: renderMailIcon(), action: () => this.props.history.push(linkToSupplierChat) },
                  { title: t('suppliers.toolbar.tooltip.phone', 'Telefonlogg – Blå ikon indikerar att något är loggat.'), component: phoneIcon, action: () => this.btnAddTextBoxClick(supplier) },
                ];

                if (supplierId?.organizationNumber && !appState.isClientRole()) {
                  actions.push({
                    title: t('suppliers.toolbar.tooltip.showSupplier', 'Visa i leverantörsdatabasen'),
                    action: () => this.props.history.push(`${url}/supplier-database`, { q: supplierId?.organizationNumber }),
                    component: <SearchIcon2 size='18' color={'var(--gray-700)'} />
                  });
                }

                const selectedSupplier = suppliers.find(supplier => supplier.reward);

                if (this.props.step > 1) {
                  if (!selectedSupplier || selectedSupplier.supplierId._id != supplierId._id) {
                    actions.push({
                      title: t('suppliers.toolbar.tooltip.addWinner', 'Välj vinnande bud och gå vidare till förhandling'),
                      component: (<div onClick={() => {
                        this.removeWinnerClickCallback();
                        this.addWinnerClickCallback(supplierId);
                        this.changeStep(3);
                      }}>
                        <WinnerIcon size="16" color={forbiddenSupplier ? "var(--gray-400)" : "var(--gray-700)"} />
                      </div>),
                      disabledFully: forbiddenSupplier || appState.isClientRole(),
                    });
                  } else {
                    actions.push({
                      title: t('suppliers.toolbar.tooltip.removeWinner', 'Avmarkera vinnande bud'),
                      action: () => {
                        this.removeWinnerClickCallback();
                        if (this.props.step != 2) {
                          this.changeStep(2);
                        }
                      },
                      component: <WinnerIcon size="16" color="var(--yellow-500)" />,
                      disabledFully: appState.isClientRole(),
                    });
                  }
                }

                if (!isReadOnlyUser) {
                  actions.push({
                    title: t('suppliers.toolbar.tooltip.removeSupplier', 'Ta bort leverantör'),
                    action: removeSupplier,
                    component: <TrashIcon size="16" style={{ fill: 'var(--gray-600)' }} />
                  });
                }

                return actions;
              };

              const decision = supplierId?.prequalification?.decision;
              const forbiddenSupplier = isBlacklist || (decision == PrequalificationDecision.INBOX || decision == PrequalificationDecision.REJECTED);

              return (
                <div key={supplierId._id} className={`${this.shouldStyleSupplierAsNotSelected(supplier) ? 'notSelectedSupplier' : ''}`} style={{display:"block"}}>
                  <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 0", borderBottom: "1px solid var(--gray-200)"}}>
                    <div className='supplierRowHeader' style={{color: forbiddenSupplier ? "var(--gray-400)" : "var(--gray-700)"}}>
                      {isBlacklist && (
                        <TooltipContainer renderReferenceComponent={ (className, ref) =>
                          <BlockIcon ref={ref} className={`${className} bid-card-blackList-icon`} />
                        }>
                          {blacklistReason?.length > 0 && <SupplierBlockedReasons reasons={blacklistReason} />}
                        </TooltipContainer>
                      )}
                      {(decision == PrequalificationDecision.INBOX || decision == PrequalificationDecision.REJECTED) && (
                        <TooltipContainer renderReferenceComponent={ (className, ref) =>
                          <BlockIcon ref={ref} className={`${className} bid-card-blackList-icon`} />
                        }>
                          <div style={{color: "var(--gray-700)", fontWeight: "400", maxWidth: "20em", whiteSpace: "normal"}}>
                            <p style={{color: "var(--gray-900)", fontWeight: "500"}}>
                              {t('suppliers.forbiddenSupplier.tooltip.notPrequalified.title', 'Leverantörsansökan ej godkänd')}
                            </p>
                            {t('suppliers.forbiddenSupplier.tooltip.notPrequalified.description', 'Ansökan måste granskas av en administratör innan leverantören används i projekt.')}
                          </div>
                        </TooltipContainer>
                      )}
                      <p className="supplier-name" title={supplierId.name} style={{ display: 'flex' }}>
                        {supplierId.frameworkAgreement && (supplierId.frameworkAgreement.file || supplierId.frameworkAgreement.validUntilDate || supplierId.frameworkAgreement.comment) &&
                          <ContractIcon style={{ marginRight: "10px", marginLeft:0, width: "20px", verticalAlign: "middle" }} />
                        }
                        <span>{supplierId.name}</span>
                      </p>
                    </div>
                    <div className='supplierRowActions'>
                      <Toolbar actions={getToolbarActions()} />
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
        {hideShowNotSelectedSuppliersControl()}
      </>
    )
  };

  renderRequestsAndBids = (buttons) => {
    const { suppliers, versionData } = this.state;
    const {t} = this.props;

    let modifiedSuppliers = suppliers.map(supplier => {
      const supplierDetails = this.getSupplierDetails(supplier?.supplierId?._id);
      return {
        ...supplier,
        bidIntentStatus: supplierDetails?.intentStatus,
        bidLink: supplierDetails?.bidLink,
        missingDemands: supplierDetails?.missingDemands,
        reservations: supplierDetails?.reservations,
        message: supplierDetails?.message,
        attachments: supplierDetails?.attachments ?? [],
        isSeen: supplierDetails?.isSeen,
        seenAt: supplierDetails?.seenAt,
        quotationValidity: supplierDetails?.quotationValidity,
        isSubmitted: supplierDetails?.isSubmitted,
        date: supplier.date ?? supplierDetails?.date,
      }
    }).filter(supplier => {
      const { supplierId } = supplier;
      const version = `version${supplierId._id}`;
      const versionInState = this.state[version];
      return versionInState || versionInState == 0;
    }).sort((a, b) => a - b);
    const showDefaultBidValidityDate = modifiedSuppliers.some(supplier => this.getQuoteValidity(supplier?.quotationValidity))

    if (modifiedSuppliers.length) {
      return (
        <Card title={t('requestsAndBids.heading', 'Förfrågningar och anbud')} gap={16}>
          <BidOverview
            modifiedSuppliers={modifiedSuppliers}
            versionData={versionData}
            showDefaultBidValidityDate={showDefaultBidValidityDate}
            removeDuplicates={this.removeDuplicates.bind(this)}
            onCalendar={this.onCalendar.bind(this)}
            changeSupplierVersion={this.changeSupplierVersion.bind(this)}
            getVersionInState={supplierId => {
              const key = `version${supplierId}`;
              return this.state[key];
            }}
            calcDaysLeft={getDaysLeft}
            currentProject={this.props.currentProject}
            areaSlug={this.props.areaSlug}
            areaName={this.props.label}
          />
          {buttons}
        </Card>
      );
    } else {
      return <></>;
    }
  };

  renderTeamBuilder = (members) => {
    const isReadOnlyUser = appState.isReadOnlyAccessRole();
    const shouldNotRender = (!isReadOnlyUser && this.state.areaUsers.length < MAX_TEAM_SIZE) || members?.length;
    if (shouldNotRender) {
      return (
        <TitleWrapper title={this.props.t('teamBuilder.heading', 'Ansvarig')}>
          <TeamBuilder users={this.props.users} areaUsers={members} setAreaUsers={(areaUsers) => this.setState({ areaUsers })} currentProject={this.props.currentProject} areaId={this.props.areaId} />
        </TitleWrapper>
      )
    } else return null;
  }

  getPhaseOptions = () => {
    const {t} = this.props;
    const { suppliers } = this.state;
    const options = [];
    if (this.props.areaStep == 1) {
      options.push({ label: t('phaseOption.evaluateBids', 'Utvärdera anbud'), action: () => this.changeStep(2) })
    } else if (this.props.areaStep == 2) {
      options.push({ label: t('phaseOption.redoRequest', 'Gör om förfrågan'), action: () => this.changeStep(1) });
      if (!appState.isReadOnlyAccessRole()) {
        options.push({ label: t('phaseOption.setWinner', 'Välj vinnande anbud'), action: () => {
          if (suppliers.find(supplier => supplier.reward)) {
            this.changeStep(3);
          } else {
            this.setState({ showWinnerModal: true })
          }
        }});
      }
    } else if (this.props.areaStep == 3 || this.props.areaStep == 4) {
      options.push({ label: t('phaseOption.redoEvaluation', 'Gör om utvärderingen'), action: () => {
        this.changeStep(2);
        this.removeWinnerClickCallback();
      }});
    }
    return options;
  }

  getVersionOptions = () => {
    return this.props.quotations
      && this.props.quotations.map(q => ({
        label: `Version ${q.version + 1}`,
        action: () => !appState.isReadOnlyAccessRole() ? this.props.createNewVersion(this.props.areaSlug, q.version) : {},
        quotationDate: formatDate(this.state.versionData?.[0]?.versions?.find(v => v.refVersion == q.version)?.quotationDate),
      }));
  }

  getAttachmentVersions = () => {
    if (!this.state.attachments) return [];
    
    const activeAttachments = this.state.attachments.filter(attachment => !attachment.deletedAt);
    
    return activeAttachments.map((attachment, index) => ({
      key: attachment.file,
      label: attachment.fileName,
      action: async () => {
        const file = attachment;
        const filename = file.file.split('.').slice(0, -1).join('.');
        const extension = this.getFileExtension(file.file);
        await ServiceDownload.downloadFile(filename, extension, file.fileName, FileScope.ProjectEvaluation, { projectId: this.props.currentProject._id, areaId: this.props.areaId });
      },
      deleteAction: async () => {
        await this.deleteAttachment(attachment);
      }
    }));
  }

  deleteAttachment = async (attachment) => {
    const { t } = this.props;
    
    try {
      await ServiceProjects.deleteAttachment(this.props.currentProject.slug, this.props.areaId, attachment.file, appState._getCurrentOrgSlug());
      
      const updatedAttachments = this.state.attachments.filter(att => att.file !== attachment.file);
      this.setState({ attachments: updatedAttachments });
      
      const project = { ...this.props.currentProject };
      const projectArea = project.area.find(area => area.areaId._id == this.props.areaId);
      if (projectArea?.attachment) {
        projectArea.attachment = projectArea.attachment.filter(att => att.file !== attachment.file);
      }
      this.props.setCurrentProject(project);

      NotificationManager.success(
        t('notification.success.attachmentDeleted.description', 'Filen har tagits bort'),
        t('notification.success.attachmentDeleted.title', 'Borttagen')
      );
    } catch (error) {
      console.error('Error deleting attachment:', error);
      NotificationManager.error(
        t('notification.error.attachmentDelete.description', 'Ett fel uppstod vid borttagning av filen'),
        t('notification.error.attachmentDelete.title', 'Fel')
      );
    }
  }

  getCopyOptions = () => {
    const list = this.props.currentProject?.area?.map(a => ({
      name: a.areaId.name,
      slug: a.areaId.slug,
      hasVersion: a.quotations?.length > 0,
      lastVersion: a.quotations?.length > 0 && a.quotations[a.quotations.length - 1].version,
      versions: a.quotations?.length > 0 && a.quotations.map(q => q.version),
    }));
    return list.filter(a => a.hasVersion).reduce((all, a) => all.concat(a.versions.toReversed().map(v => ({
      label: a.name + ", version " + (v + 1),
      value: "?source=" + a.slug + ":" + (v + 1),
    }))), []);
  }

  renderPhaseTransitionDropdown = () => {
    const isReadOnlyUser = appState.isReadOnlyAccessRole();
    const { areaStep, wizard } = this.props;
    const selectedStep = wizard.find(element => areaStep == element.step);

    return !isReadOnlyUser && (
      <TitleWrapper title={this.props.t('phaseOption.label', 'Status')}>
        <OptionsMenu options={this.getPhaseOptions()}>
          <BtButton rightIcon={<ArrowIcon />} class='gray'>
            {selectedStep.name}
          </BtButton>
        </OptionsMenu>
      </TitleWrapper>
    )
  }

  renderBudgetInput = () => {
    const {t} = this.props;
    const isReadOnlyUser = appState.isReadOnlyAccessRole();
    const { changeAreaBudget } = this.props;
    const { budgetVal } = this.state;
    const budgetValFormatted = formatAmount(budgetVal);
    return (!isReadOnlyUser || budgetValFormatted) && (
      <TitleWrapper title={t('budget.label', 'Budget')}>
        <div className="bitcard-budget-pricetype-row">
          <div className={`bitcard-budget-section`}>
            <Field
              className={`${isReadOnlyUser && budgetValFormatted ? 'readOnlyAccess' : ''} budgetFieldOnSinglePurchasePage`}
              placeholder={t('budget.placeholder', 'Skriv med siffror')}
              value={budgetValFormatted}
              onChange={value => this.setState({ budgetVal: value })}
              onBlur={e => changeAreaBudget(e)}
              disabled={isReadOnlyUser}
              unit={t('budget.unit', 'kr')}
            />
          </div>
        </div>
      </TitleWrapper>
    )
  }

  renderFirstStepControls = () => {
    const isReadOnlyUser = appState.isReadOnlyAccessRole();
    const url = appState._getCurrentOrgUrl();
    const { step, createNewVersion, areaSlug, history, currentProject, t } = this.props;
    const { suppliers, showAllVersions } = this.state;

    const versionOptions = (this.getVersionOptions() ?? []).reverse();
    const shouldShowTitle = suppliers?.length > 0 && (step == 1 || step == 2 || (versionOptions?.length > 0));

    const shownVersionOptions = showAllVersions ? versionOptions : versionOptions.slice(0,3);
    return shouldShowTitle && (
      <Card title={t('request.heading', 'Förfrågningsunderlag')} gap={16}>
        {shownVersionOptions.length ? (
          <div style={{display: "flex", flexDirection: "column", gap: 16}}>
            <table className={styles.documents}>
              <thead>
                <tr>
                  <th>{t('request.table.header.versionLabel', 'Version')}</th>
                  <th>{t('request.table.header.quotationDate', 'Skickad')}</th>
                </tr>
              </thead>
              <tbody>
                {shownVersionOptions?.map(v => (
                  <tr key={v.label} onClick={v.action}>
                    <th>{v.label}</th>
                    <td>{v.quotationDate}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {versionOptions.length > 3 && (
              <div className={styles.documentLink} style={{textAlign: "center"}} onClick={() => this.setState({showAllVersions: !showAllVersions})}>
                { showAllVersions ? t('request.hideOldVersions', 'Dölj gamla versioner') : t('request.showAllVersions', 'Visa alla versioner') }
              </div>
            )}
          </div>
        ) : (
          <div className={styles.noVersions}>{t('request.emptyMessage', 'Det finns inga förfrågningsunderlag, skapa ett med knappen nedan.')}</div>
        )}
        <div style={{flexGrow: 1, display: "flex", flexDirection: "column", justifyContent: "flex-end"}}>
          <div className='secondRowBidCardControls' style={{flexWrap: "wrap"}}>
            {!isReadOnlyUser && step == 1 && (
              <>
                <BtButton
                  leftIcon={<AddIcon color='var(--white)'/>}
                  style={{ width: 'fit-content' }}
                  onClick={() => createNewVersion(areaSlug)}
                  class='dark'
                >
                  {t('request.button.new', 'Nytt förfrågningsunderlag')}
                </BtButton>
                <BtButton
                  leftIcon={<AddIcon color='var(--gray-700)'/>}
                  style={{ width: 'fit-content' }}
                  onClick={() => this.setState({ showCopyModal: true })}
                  color="gray"
                  disabled={!this.props.currentProject.area.find(a => a.quotations && a.quotations.length > 0)}
                >
                  {t('request.button.copy', 'Kopiera befintligt')}
                </BtButton>
                <Modal
                  show={this.state.showCopyModal}
                  setShow={(value) => this.setState({ showCopyModal: value, copySource: null })}
                  title={t('request.copy.title', 'Kopiera förfrågningsunderlag')}
                  buttonInfo={{
                    label: t('request.copy.button', 'Kopiera förfrågningsunderlag'),
                    action: () => { createNewVersion(areaSlug, undefined, this.state.copySource?.value )},
                    disabled: !this.state.copySource,
                  }}
                >
                  <Selector
                    label={t('request.copy.label', 'Välj källa')}
                    options={this.getCopyOptions()}
                    value={this.state.copySource}
                    onChange={(value => this.setState({ copySource: value }))}
                  />
                </Modal>
              </>
            )}

            <BtButton
              style={{ width: 'fit-content' }}
              onClick={() => history.push(`${url}/projects/${currentProject.slug}/${areaSlug}/tips`)}
              class='gray'
            >
              {t('request.button.tips', 'Upphandlingstips')}
            </BtButton>
          </div>
        </div>
      </Card>
    )
  }

  renderSecondStepControls = () => {
    const isReadOnlyUser = appState.isReadOnlyAccessRole();
    const { step, t } = this.props;
    const { attachments } = this.state;

    return ((!isReadOnlyUser && step == 2) || attachments?.length > 0) && (
      <div className='secondRowBidCardControls'>
        {!isReadOnlyUser && step == 2 && (
          <>
            <input
              accept=".xls,.xlsx,.xlt,.xla,.xltx"
              style={{ display: 'none' }}
              type="file"
              multiple
              onClick={event => {
                event.target.value = null;
              }}
              onChange={this.elInputFileChangeCallback.bind(this)}
              ref={el => (this.elInputFile = el)}
            />
            <BtButton
              style={{ width: 'fit-content' }}
              leftIcon={<img className="excel-icon" src={ExcelIcon} />}
              onClick={() => this.exportBidCardInfoOnExcel()}
              class='gray'
            >
              {t('requestsAndBids.button.export', 'Exportera till Excel')}
            </BtButton>
            <BtButton
              style={{ width: 'fit-content' }}
              leftIcon={<UploadIcon color='var(--gray-700)' />}
              onClick={() => this.elBtnAttachClickCallback()}
              class='gray'
            >
              {t('requestsAndBids.button.upload', 'Ladda upp utvärdering')}
            </BtButton>
          </>
        )}
        {attachments?.length > 0 && (
          <OptionsMenu options={this.getAttachmentVersions()}>
            <BtButton
              style={{ width: 'fit-content' }}
              leftIcon={<img className="excel-icon" src={ExcelIcon} />}
              rightIcon={<ArrowIcon />}
              class='gray'
            >
              {t('requestsAndBids.button.openAttachment', 'Öppna utvärdering')}
            </BtButton>
          </OptionsMenu>
        )}
      </div>
    )
  }

  renderThirdStepControls = () => {
    const isReadOnlyUser = appState.isReadOnlyAccessRole();
    const { step, uploadContract, createContract, t } = this.props;
    const val = this.props.currentProject.area.find(a => a.areaId._id == this.props.areaId);

    const getContractStatusDot = (contract, isManualContract) => {
      let color = 'var(--yellow-500)';
      let char = '⋯'
      if (isManualContract) {
        color = 'var(--gray-400)';
        char = '•';
      } else {
        const { lastStatus, signedAt } = contract || {};
        if (signedAt) {
          color = 'var(--green-500)';
          char = '✓';
        } else if (['canceled', 'timedout', 'rejected', 'document_error'].includes(lastStatus)) {
          color = 'var(--red-500)';
          char = '✗';
        }
      }
      return <span style={{ color, width: '1.5em', display: 'inline-block', textAlign: 'center' }}>{char}</span>
    }

    const getContractStatusText = (contract, isManualContract) => {
      if (isManualContract) return t('contract.status.manuallySigned', 'Manuellt signerat');
      if (contract.signedAt) return t('contract.status.signedAt', 'E-signerat {{signedAt}}', { signedAt: formatDate(contract.signedAt) });
      return {
        canceled: t('contract.status.canceled', 'Återkallat'),
        timedout: t('contract.status.timedout', 'Utgånget'),
        rejected: t('contract.status.rejected', 'Nekat'),
        document_error: t('contract.status.document_error', 'Dokumentfel'),
      }[contract.lastStatus] ?? t('contract.status.pending', 'Väntar på signering');
    };

    const contracts = (val.contracts || []).map(c => ({
      label: <span>{getContractStatusDot(c)} {shortFilename(c.fileName, 50)}</span>,
      action: () => this.showContractStatus(c),
      contract: c,
      key: c.documentId,
      status: getContractStatusText(c, false),
      sent: formatDate(c.createdAt),
    }));

    const manualContracts = (this.props.manualContract || []).map(c => ({
      label: <span>{getContractStatusDot(c, true)} {shortFilename(c.fileName, 50)}</span>,
      action: () => this.showContractStatus(c),
      key: c._id,
      status: t('contract.status.manuallySigned', 'Manuellt signerat'),
      sent: formatDate(c.createdAt),
    }));

    const allContracts = [
      ...contracts,
      ...manualContracts
    ];

    return ((!isReadOnlyUser && step == 3) || allContracts.length > 0) && (
      <Card title={t('contract.heading', 'Avtal')} gap={16}>
        {allContracts.length > 0 && (
          <table className={styles.documents}>
            <thead>
              <tr>
                <th>{t('contract.table.header.name', 'Namn')}</th>
                <th>{t('contract.table.header.status', 'Status')}</th>
                <th>{t('contract.table.header.created', 'Skapad')}</th>
              </tr>
            </thead>
            <tbody>
              {allContracts.map(v => (
                <tr onClick={v.action} key={v.key}>
                  <th>{v.label}</th>
                  <td>{v.status}</td>
                  <td>{v.sent}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {!isReadOnlyUser && step >= 3 && (
          <div className="secondRowBidCardControls">
            <BtButton leftIcon={<PlusIcon/>} class="gray" onClick={createContract}>{t('contract.button.add.eSign', 'Lägg till och e-signera med Scrive')}</BtButton>
            <BtButton leftIcon={<PlusIcon/>} class="gray" onClick={uploadContract}>{t('contract.button.add.manualSign', 'Lägg till manuellt signerat')}</BtButton>
          </div>
        )}
      </Card>
    )
  }

  async showContractStatus(contract) {
    this.setState({
      selectedContract: contract,
      showAgreementModal: true,
      agreementModalKey: this.state.agreementModalKey + 1,
    });
  }

  render() {
    const { t, currentProject, areaSlug } = this.props;
    let dateEnd = this.getLocalDateTime(moment(this.props.dateEnd).startOf('day').toDate());
    let suppliers = this.state.suppliers;

    const {
      selectedItem,
      phoneLogValue,
      showPhoneLogModal,
      phoneLogLoading,
      phoneLogRefreshKey,
      localPhoneLogDetails,
      areaUsers,
      showWinnerModal,
      winnerValue,
      temporaryAreaLeadTime,
    } = this.state;
    dateEnd = this.parseDateEnd(dateEnd);
    if (dateEnd && typeof dateEnd == 'number') dateEnd = new Date(dateEnd);
    if (!(dateEnd instanceof Date)) dateEnd = null;

    const isReadOnlyUser = appState.isReadOnlyAccessRole();

    const phoneLogDetails = showPhoneLogModal ? localPhoneLogDetails : this.getCallDetails(selectedItem);

    const area = currentProject.area.find(area => area.areaId._id == this.props.areaId);

    const quotationSentBy = area?.quotationSentBy && moment(area.quotationSentBy);
    const answersLatestBy = area?.answersLatestBy && moment(area.answersLatestBy);
    const purchaseCompleted = area?.purchaseCompleted && moment(area.purchaseCompleted);
    const productionStartsAt = area?.productionStartsAt && moment(area?.productionStartsAt);
    const productionEndsAt = area?.productionEndsAt && moment(area?.productionEndsAt);
    const areaLeadTime = (area?.leadTime || area?.leadTime === 0) ? area?.leadTime : undefined;
    const { value, updating } = temporaryAreaLeadTime[area.areaId._id] || {};
    const temporaryLeadTime = updating ? value : areaLeadTime;
    const leadTimeInWeeks = (temporaryLeadTime || temporaryLeadTime === 0) ? temporaryLeadTime / (1000 * 60 * 60 * 24 * 7) : undefined;

    let errorMessage = '';
    if (productionStartsAt && purchaseCompleted && areaLeadTime) {
      const calculatedLeadTime = moment(productionStartsAt).diff(purchaseCompleted, 'milliseconds');
      const calculatedLeadTimeInWeeks = calculatedLeadTime / (1000 * 60 * 60 * 24 * 7);
      const leadTimeInWeeks = areaLeadTime / (1000 * 60 * 60 * 24 * 7);
      const leadTimesDontMatch = calculatedLeadTimeInWeeks < leadTimeInWeeks;
      const purchaseCompletedDateIsAfterProductionsStartsDate = moment(purchaseCompleted).isSameOrAfter(productionStartsAt);
      errorMessage = (leadTimesDontMatch || purchaseCompletedDateIsAfterProductionsStartsDate) ? (
        <div style={{ maxWidth: '200px', whiteSpace: 'normal' }}>
          {t(
            'productionStartsAt.errorMessage',
            'Inte tillräckligt med tid mellan inköp klart och leveransstart (med {{leadTimeInWeeks}} veckors ledtid)',
            { leadTimeInWeeks } )
          }
        </div>
      ) : '';
    }

    const versions = this.state.versionData?.[0]?.versions;
    const areaSuppliers = area?.suppliers;

    let latestExpirationDate;
    if (area?.answersLatestBy && !_.isEmpty(versions)) {
      const latestVersionPerSupplier = {};

      versions.forEach(version => {
        const refVersion = version.refVersion;
        const suppliers = version?.suppliers?.filter(versionSupplier => areaSuppliers.find(areaSupplier => areaSupplier.supplierId._id === versionSupplier.supplierId));
        suppliers.forEach(supplier => {
          if (!latestVersionPerSupplier[supplier.supplierId] || refVersion > latestVersionPerSupplier[supplier.supplierId].refVersion ) {
            latestVersionPerSupplier[supplier.supplierId] = version;
          }
        })
      });

      Object.entries(latestVersionPerSupplier).map(([id, version]) => {
        const refVersion = version.refVersion;
        const expiryDate = version.quotationExpiryDate;
        const latestExtension = version.updatedSuppliers.find(sup => sup.supplierId === id && sup.version === refVersion)?.endDate;
        const selectedDate = moment(latestExtension).isAfter(expiryDate) ? latestExtension : expiryDate;
        if (!latestExpirationDate || moment(selectedDate).isAfter(latestExpirationDate)) {
          latestExpirationDate = selectedDate;
        }
      })
    }

    const latestExpirationIsAfterplannedDate = area?.answersLatestBy && !_.isEmpty(versions) && moment(latestExpirationDate).isAfter(area.answersLatestBy, 'day');

    return (<div className="app-project-single-purchase">
      <Card title={t('general.heading', 'Allmänt')} gap={16}>
        <div className='firstRowBidCardControls'>
          {this.renderPhaseTransitionDropdown()}
          {this.renderBudgetInput()}
          {this.renderTeamBuilder(areaUsers)}
        </div>
        <div className={styles.datesControls}>
          <span>{t('general.time.heading', 'Tidsplanering')}</span>
          <div>
            <TableDatePicker
              label={t('general.time.label.quotationSentBy', 'Förfrågan skickas senast')}
              fieldClassName={styles.projectAreaDatePicker}
              date={quotationSentBy?.toDate()}
              onFocusStylesEnabled={false}
              isClearable
              onChange={async date => {
                await ServiceProjects.updateProjectAreaQuotationSentBy(currentProject.slug, areaSlug, date);
              }}
            />
            <TableDatePicker
              label={t('general.time.label.answersLatestBy', 'Svar senast')}
              warningMessage={latestExpirationIsAfterplannedDate ? (
                <div style={{ maxWidth: '250px', whiteSpace: 'normal' }}>
                  {t(
                    'general.time.answersLatestBy.warningMessage',
                    'Minst en leverantör har fått en förfrågan med senare anbudsdatum än detta ({{latestExpirationDate}}).',
                    { latestExpirationDate: moment(latestExpirationDate).locale('sv').format('D MMMM YYYY') } )
                  }
                </div>
              ) : ''}
              fieldClassName={styles.projectAreaDatePicker}
              date={answersLatestBy?.toDate()}
              onFocusStylesEnabled={false}
              isClearable
              onChange={async date => {
                await ServiceProjects.updateProjectAreaAnswersLatestBy(currentProject.slug, areaSlug, date);
              }}
            />
            <TableDatePicker
              label={t('general.time.label.purchaseCompleted', 'Inköp klart')}
              fieldClassName={styles.projectAreaDatePicker}
              date={purchaseCompleted?.toDate()}
              onFocusStylesEnabled={false}
              isClearable
              onChange={async date => {
                await ServiceProjects.updateAndAutocompleteFields(currentProject.slug, areaSlug, 'purchaseCompleted', {
                  purchaseCompleted: date,
                  leadTime: areaLeadTime,
                  productionStartsAt,
                })
              }}
            />
            <div>
              <TableField
                label={t('general.time.label.leadTime', 'Ledtid')}
                value={leadTimeInWeeks}
                onFocusStylesEnabled={false}
                className={styles.projectAreaDatePicker}
                onBlur={async (value) => {
                  await ServiceProjects.updateAndAutocompleteFields(currentProject.slug, area.areaId.slug, 'leadTime', {
                    purchaseCompleted,
                    leadTime: value,
                    productionStartsAt,
                  });
                }}
                isLeadTime
              />
            </div>
            <TableDatePicker
              label={t('general.time.label.productionStart', 'Leveransstart')}
              fieldClassName={styles.projectAreaDatePicker}
              date={productionStartsAt?.toDate()}
              onFocusStylesEnabled={false}
              errorMessage={errorMessage}
              isClearable
              onChange={async date => {
                await ServiceProjects.updateAndAutocompleteFields(currentProject.slug, areaSlug, 'productionStartsAt', {
                  purchaseCompleted,
                  leadTime: areaLeadTime,
                  productionStartsAt: date,
                })
              }}
            />
            <TableDatePicker
              label={t('general.time.label.productionEnd', 'Leveransslut')}
              fieldClassName={styles.projectAreaDatePicker}
              date={productionEndsAt?.toDate()}
              onFocusStylesEnabled={false}
              isClearable
              onChange={async date => {
                await ServiceProjects.updateProjectAreaProductionEndsAt(currentProject.slug, areaSlug, date);
              }}
            />
          </div>
        </div>
      </Card>

      <div className={styles.row}>
        <Card title={t('suppliers.heading', 'Leverantörer')} gap={16}>
          {this.renderSuppliers()}

          {!isReadOnlyUser && (
            <div style={{flexGrow: 1, display: "flex", flexDirection: "column", justifyContent: "flex-end", alignItems: "flex-start"}}>
              <BtButton
                leftIcon={<AddIcon color='var(--white)' />}
                style={{ marginTop: '15px' }}
                class='dark'
                onClick={() => this.props.addSupplier(currentProject.area.find(area => area.areaId._id == this.props.areaId))}
              >
                {t('suppliers.button.add', 'Lägg till leverantör')}
              </BtButton>
            </div>
          )}
        </Card>

        {this.renderFirstStepControls()}
      </div>

      {this.renderRequestsAndBids(this.renderSecondStepControls())}

      {this.renderThirdStepControls()}

      <Modal
        title={t('phoneLog.heading', 'Kommentarer')}
        show={showPhoneLogModal}
        setShow={(value) => this.setState({ showPhoneLogModal: value })}
        buttonInfo={!appState.isReadOnlyAccessRole() && {
          label: t('phoneLog.button.add', 'Lägg till'), 
          action: async () => {
            if (phoneLogValue && phoneLogValue.trim()) {
              this.setState({ phoneLogLoading: true });
              try {
                await this.props.onCallDetail(phoneLogValue, selectedItem);
                const newEntry = {
                  detail: phoneLogValue,
                  date: new Date().toISOString(),
                  userId: appState.getUserId(),
                  name: appState.getUserName() || 'Unknown',
                  avatarUrl: getImageUrl(appState.getLoggedInUserDetail()?.imgId, appState.getCurrentOrgSlug(), FileScope.UserAvatar, { userId: appState.getUserId() })
                };
                
                this.setState({ 
                  phoneLogValue: '', 
                  phoneLogLoading: false,
                  localPhoneLogDetails: [...this.state.localPhoneLogDetails, newEntry]
                });
                
                setTimeout(() => {
                  if (this.phoneLogDiv) {
                    const scrollHeight = this.phoneLogDiv.scrollHeight;
                    const height = this.phoneLogDiv.clientHeight;
                    const maxScrollTop = scrollHeight - height;
                    this.phoneLogDiv.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
                  }
                }, 100);
                
                // Keep modal open - don't close it
              } catch (error) {
                this.setState({ phoneLogLoading: false });
                console.error('Error adding phone log:', error);
              }
            }
          },
          loaderShow: phoneLogLoading,
          disabled: !phoneLogValue || phoneLogValue.trim() === '' || phoneLogLoading
        }}
      >
        {phoneLogDetails?.length > 0 ? (
          <div key={`phone-log-${localPhoneLogDetails.length}`} style={{ maxHeight: '50vh', overflowY: 'auto', marginBottom: '10px', display: 'grid', gap: '20px' }} ref={(el) => { this.phoneLogDiv = el }}>
            {this.renderPhoneLogs(phoneLogDetails)}
          </div>
        ) : (
          <span style={{ alignSelf: 'center', marginBottom: '16px' }}>{t('phoneLog.emptyMessage', 'Telefonloggen är tom')}</span>
        )}

        {!appState.isReadOnlyAccessRole() && (
          <TitleWrapper title={t('phoneLog.select.label', 'Skriv telefonlogg')}>
            <Editor
              value={phoneLogValue}
              onChange={(value) => this.setState({ phoneLogValue: value })}
              wrapperStyle={{ width: '600px', height: '200px' }}
            />
          </TitleWrapper>
        )}
      </Modal>

      <Modal
        title={t('setWinner.heading', 'Välj vinnande leverantör')}
        show={showWinnerModal}
        setShow={(value) => this.setState({ showWinnerModal: value })}
        buttonInfo={{
          label: t('setWinner.button', 'Gå vidare till förhandling'),
          action: () => {
            const supplier = suppliers.find(supplier => supplier.supplierId._id == winnerValue.value);
            this.addWinnerClickCallback(supplier.supplierId);
            this.changeStep(3);
            this.setState({ showWinnerModal: false });
          },
          disabled: !winnerValue,
        }}
      >
        <TitleWrapper title={t('setWinner.label', 'Välj den leverantör du vill gå vidare med')}>
          <Selector
            value={winnerValue}
            onChange={(value) => this.setState({ winnerValue: value })}
            options={suppliers
              .filter(supplier => !supplier.supplierId?.isBlacklist)
              .filter(supplier => !["INBOX", "REJECTED"].includes(supplier.supplierId?.prequalification?.decision))
              .map(supplier => ({ label: supplier.supplierId.name, value: supplier.supplierId._id }))
            }
            placeholder=''
          />
        </TitleWrapper>
      </Modal>

      {this.state.showAgreementModal && (
        <Modal
          title={t('contract.heading', 'Avtal')}
          show={this.state.showAgreementModal}
          setShow={(value) => this.setState({ showAgreementModal: value })}
          hasCloseButton
        >
          <ContractModal
            deleteContract={this.props.deleteContract}
            currentProject={currentProject}
            areaSlug={areaSlug}
            areaId={this.props.areaId}
            isReadOnlyUser={isReadOnlyUser}
            hideModal={() => this.setState({ showAgreementModal: false })}
            selectedContract={this.state.selectedContract}
            refreshCurrentProject={this.props.refreshCurrentProject}
            key={this.state.agreementModalKey}
          />
        </Modal>
      )}

      {selectedItem && <DateExtensionModal
        show={this.state.showDateExtensionModal}
        setShow={(value) => this.setState({ showDateExtensionModal: value })}
        defaultDate={new Date(selectedItem?.date ? selectedItem.date : dateEnd)}
        onSave={this.onSave}
        data={{
          areaName: this.props.label,
          projectName: currentProject.name,
          version: this.state.currentSelectedVersion
        }}
      />}

      <div className={styles.row}>
        <Card title={t('files.heading', 'Filer')} gap={16}>
          <FileArea 
            root={`/purchase-files/${this.props.currentProject._id}/${this.props.areaId}`} 
            path={this.state.fileAreaPath} 
            setPath={(getNewPath) => {
              const newPath = getNewPath(this.state.fileAreaPath);
              this.setState({ fileAreaPath: newPath });
            }}
            isAllowedToUpload={appState.isWriteAccessRole()}
            isAllowedToDownload={appState.isCustomerUser()}
            isAllowedToDelete={appState.isWriteAccessRole()}
          />
        </Card>
      </div>
    </div>);

    
  }
}

export default withTranslation('projects', { keyPrefix: 'singlePurchase' })(withRouter(AppProjectSinglePurchase));
